import * as yup from 'yup'
import { defineMessages } from 'react-intl'

import { ORDER_TYPE } from 'features/Inventories/components/OrderType/constants'

const purchaseIdMessages = defineMessages({
  required: {
    id: 'spanish.items.receive.purchaseId.required',
    defaultMessage: 'El id de compra es requerido'
  }
})

const supplierMessages = defineMessages({
  required: {
    id: 'spanish.items.receive.supplier.required',
    defaultMessage: 'El supplier es requerido'
  }
})

const packagesQuantityMessages = defineMessages({
  required: {
    id: 'spanish.items.receive.packagesQuantity.required',
    defaultMessage: 'La cantidad es requerida'
  }
})

const itemIdMessages = defineMessages({
  required: {
    id: 'spanish.items.receive.itemId.required',
    defaultMessage: 'Se necesita seleccionar un producto'
  }
})

const itemPriceMessages = defineMessages({
  required: {
    id: 'spanish.items.receive.itemPrice.required',
    defaultMessage: 'El precio es requerido'
  }
})

const itemQuantityMessages = defineMessages({
  required: {
    id: 'spanish.items.receive.itemQuantity.required',
    defaultMessage: 'La cantidad es requerida'
  }
})

const destinationMessages = defineMessages({
  required: {
    id: 'spanish.inventories.items.removed.destination.required',
    defaultMessage: 'El destino es requerido'
  }
})

// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
export const schema = (intl): TSFixMe => {
  return yup.object().shape({
    type: yup.string(),
    purchaseId: yup.string().when('type', {
      is: ORDER_TYPE.PURCHASE,
      then: yup.string().required(intl.formatMessage(purchaseIdMessages.required))
    }),
    supplier: yup.string().when('type', {
      is: ORDER_TYPE.PURCHASE,
      then: yup.string().required(intl.formatMessage(supplierMessages.required))
    }),
    destination: yup
      .object()
      .shape({
        id: yup.string()
      })
      .when('type', {
        is: ORDER_TYPE.SHIPMENT,
        then: yup.object().shape({
          id: yup.string().required(intl.formatMessage(destinationMessages.required))
        })
      }),
    items: yup.array().of(
      yup.object().shape({
        isPackage: yup.boolean(),
        isMixed: yup.boolean(),
        packagesQuantity: yup.string().when('isPackage', {
          is: true,
          then: yup.string().required(intl.formatMessage(packagesQuantityMessages.required))
        }),
        nestedItems: yup.array().of(
          yup.object().shape({
            id: yup.string().required(intl.formatMessage(itemIdMessages.required)),
            quantity: yup.string().required(intl.formatMessage(itemQuantityMessages.required)),
            price: yup
              .string()
              .test('is-price-required', intl.formatMessage(itemPriceMessages.required), function (price) {
                // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                const objectToValidate = this.from[this.from.length - 1].value

                return objectToValidate.type === ORDER_TYPE.SHIPMENT || !!price
              })
          })
        )
      })
    )
  })
}
